/* @minVersion 7.17.0 */

export default function _identity<T>(x: T) {
  return x;
}
